import { Card, CardContent } from "./ui/card";
import { PrayerCard } from "./PrayerCard";
import { UserCircle } from "lucide-react";

function groupByRequester(prayers) {
  const groups = {};
  prayers.forEach((prayer) => {
    const requester = prayer.requested_by || "Unknown";
    if (!groups[requester]) groups[requester] = [];
    groups[requester].push(prayer);
  });
  return Object.entries(groups).sort((a, b) => b[1].length - a[1].length);
}

export function PrayerTabContent({
  prayers,
  emptyIcon: EmptyIcon,
  emptyMessage,
  emptyHint,
  sortMode,
  accentColor = "#4A6741",
  isAnswered = false,
  onMarkAnswered,
  onEdit,
  onDelete,
  onPrayedFor,
  isOwner,
  testIdPrefix = "",
  selectable = false,
  selectedIds = [],
  onSelectToggle,
}) {
  if (prayers.length === 0) {
    return (
      <Card className="border-stone border-dashed">
        <CardContent className="p-8 text-center">
          <EmptyIcon className="w-12 h-12 mx-auto mb-4" style={{ color: `${accentColor}30` }} />
          <p className="text-stone-dark/60">{emptyMessage}</p>
          {emptyHint && <p className="text-sm text-stone-dark/40 mt-1">{emptyHint}</p>}
        </CardContent>
      </Card>
    );
  }

  if (sortMode === "requester") {
    return groupByRequester(prayers).map(([requester, prayerGroup]) => (
      <div key={requester} className="space-y-3" data-testid={`${testIdPrefix}requester-group-${requester}`}>
        <div className="flex items-center gap-2 pt-2">
          <UserCircle className="w-5 h-5" style={{ color: accentColor }} />
          <h3 className="font-serif text-base font-semibold" style={{ color: accentColor }}>{requester}</h3>
          <span className="text-xs text-stone-dark/40 bg-stone/50 px-2 py-0.5 rounded-full">{prayerGroup.length}</span>
        </div>
        {prayerGroup.map((prayer) => (
          <PrayerCard
            key={prayer.id}
            prayer={prayer}
            onMarkAnswered={onMarkAnswered ? () => onMarkAnswered(prayer) : undefined}
            onEdit={onEdit ? () => onEdit(prayer) : undefined}
            onDelete={onDelete ? () => onDelete(prayer.id) : undefined}
            onPrayedFor={onPrayedFor ? () => onPrayedFor(prayer) : undefined}
            isAnswered={isAnswered}
            isOwner={isOwner}
            selectable={selectable}
            selected={selectedIds.includes(prayer.id)}
            onSelectToggle={onSelectToggle}
          />
        ))}
      </div>
    ));
  }

  return prayers.map((prayer) => (
    <PrayerCard
      key={prayer.id}
      prayer={prayer}
      onMarkAnswered={onMarkAnswered ? () => onMarkAnswered(prayer) : undefined}
      onEdit={onEdit ? () => onEdit(prayer) : undefined}
      onDelete={onDelete ? () => onDelete(prayer.id) : undefined}
      onPrayedFor={onPrayedFor ? () => onPrayedFor(prayer) : undefined}
      isAnswered={isAnswered}
      isOwner={isOwner}
      selectable={selectable}
      selected={selectedIds.includes(prayer.id)}
      onSelectToggle={onSelectToggle}
    />
  ));
}
